<template>
	<div id="video-call">
		<nav-bar name="Video Llamada"></nav-bar>
		<video-call-frame :callid="callId"></video-call-frame>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import NavBar from "@/components/NavBar.vue";
	import VideoCallFrame from "@/components/VideoCallFrame.vue";
import { RouteLocationNormalizedLoaded, useRoute } from "vue-router";

	export default defineComponent({
		components: {
			VideoCallFrame,
			NavBar,
		},
		setup() {
			const route : RouteLocationNormalizedLoaded = useRoute()

			return {
				callId: route.query.id
			}
		},
	});
</script>

<style lang="stylus" scoped>
	#video-call {
		display: grid;
		grid-template-rows: auto 1fr;
		height: 100vh;
	}
</style>